import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _get from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/get.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var TileDocument_1;
import jsonpatch from 'fast-json-patch';
import * as dagCbor from '@ipld/dag-cbor';
import * as uint8arrays from 'uint8arrays';
import { randomBytes } from '@stablelib/random';
import { Stream, StreamStatic, SyncOptions } from '@ceramicnetwork/common';
import { CommitID, StreamRef } from '@ceramicnetwork/streamid';
var DEFAULT_CREATE_OPTS = {
  anchor: true,
  publish: true,
  pin: true,
  sync: SyncOptions.PREFER_CACHE
};
var DEFAULT_LOAD_OPTS = {
  sync: SyncOptions.PREFER_CACHE
};
var DEFAULT_UPDATE_OPTS = {
  anchor: true,
  publish: true,
  throwOnInvalidCommit: true
};
function headerFromMetadata(metadata, genesis) {
  var _metadata$schema;
  if (typeof (metadata === null || metadata === void 0 ? void 0 : metadata.schema) === 'string') {
    try {
      CommitID.fromString(metadata.schema);
    } catch (_unused) {
      throw new Error('Schema must be a CommitID');
    }
  }
  var header = {
    controllers: metadata === null || metadata === void 0 ? void 0 : metadata.controllers,
    family: metadata === null || metadata === void 0 ? void 0 : metadata.family,
    schema: metadata === null || metadata === void 0 ? void 0 : (_metadata$schema = metadata.schema) === null || _metadata$schema === void 0 ? void 0 : _metadata$schema.toString(),
    tags: metadata === null || metadata === void 0 ? void 0 : metadata.tags
  };
  if (genesis) {
    if (!(metadata !== null && metadata !== void 0 && metadata.deterministic)) {
      header.unique = uint8arrays.toString(randomBytes(12), 'base64');
    }
    if (metadata !== null && metadata !== void 0 && metadata.forbidControllerChange) {
      header.forbidControllerChange = true;
    }
  } else {
    if ((metadata === null || metadata === void 0 ? void 0 : metadata.deterministic) !== undefined || (metadata === null || metadata === void 0 ? void 0 : metadata.unique) !== undefined) {
      throw new Error("Cannot change 'deterministic' or 'unique' properties on existing Streams");
    }
    if ((metadata === null || metadata === void 0 ? void 0 : metadata.forbidControllerChange) !== undefined) {
      throw new Error("Cannot change 'forbidControllerChange' property on existing Streams");
    }
  }
  Object.keys(header).forEach(function (key) {
    return header[key] === undefined && delete header[key];
  });
  return header;
}
function _ensureAuthenticated(_x) {
  return _ensureAuthenticated2.apply(this, arguments);
}
function _ensureAuthenticated2() {
  _ensureAuthenticated2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(signer) {
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          if (!(signer.did == null)) {
            _context9.next = 2;
            break;
          }
          throw new Error('No DID provided');
        case 2:
          if (signer.did.authenticated) {
            _context9.next = 6;
            break;
          }
          _context9.next = 5;
          return signer.did.authenticate();
        case 5:
          if (signer.loggerProvider) {
            signer.loggerProvider.getDiagnosticsLogger().imp("Now authenticated as DID ".concat(signer.did.id));
          }
        case 6:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _ensureAuthenticated2.apply(this, arguments);
}
function _signDagJWS(_x2, _x3) {
  return _signDagJWS2.apply(this, arguments);
}
function _signDagJWS2() {
  _signDagJWS2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(signer, commit) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return _ensureAuthenticated(signer);
        case 2:
          return _context10.abrupt("return", signer.did.createDagJWS(commit));
        case 3:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _signDagJWS2.apply(this, arguments);
}
function throwReadOnlyError() {
  return _throwReadOnlyError.apply(this, arguments);
}
function _throwReadOnlyError() {
  _throwReadOnlyError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          throw new Error('Historical stream commits cannot be modified. Load the stream without specifying a commit to make updates.');
        case 1:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _throwReadOnlyError.apply(this, arguments);
}
var TileDocument = TileDocument_1 = /*#__PURE__*/function (_Stream) {
  _inherits(TileDocument, _Stream);
  var _super = _createSuper(TileDocument);
  function TileDocument() {
    var _this;
    _classCallCheck(this, TileDocument);
    _this = _super.apply(this, arguments);
    _this._isReadOnly = false;
    return _this;
  }
  _createClass(TileDocument, [{
    key: "content",
    get: function get() {
      return _get(_getPrototypeOf(TileDocument.prototype), "content", this);
    }
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(content, metadata) {
        var opts,
          signer,
          updateCommit,
          updated,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              opts = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_UPDATE_OPTS), opts);
              signer = opts.asDID ? {
                did: opts.asDID
              } : this.api;
              _context.next = 5;
              return this.makeCommit(signer, content, metadata);
            case 5:
              updateCommit = _context.sent;
              _context.next = 8;
              return this.api.applyCommit(this.id, updateCommit, opts);
            case 8:
              updated = _context.sent;
              this.state$.next(updated.state);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function update(_x4, _x5) {
        return _update.apply(this, arguments);
      }
      return update;
    }()
  }, {
    key: "patch",
    value: function () {
      var _patch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(jsonPatch) {
        var opts,
          header,
          rawCommit,
          commit,
          updated,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_UPDATE_OPTS), opts);
              header = headerFromMetadata(this.metadata, false);
              rawCommit = {
                header: header,
                data: jsonPatch,
                prev: this.tip,
                id: this.state$.id.cid
              };
              _context2.next = 6;
              return _signDagJWS(this.api, rawCommit);
            case 6:
              commit = _context2.sent;
              _context2.next = 9;
              return this.api.applyCommit(this.id, commit, opts);
            case 9:
              updated = _context2.sent;
              this.state$.next(updated.state);
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function patch(_x6) {
        return _patch.apply(this, arguments);
      }
      return patch;
    }()
  }, {
    key: "makeReadOnly",
    value: function makeReadOnly() {
      this.update = throwReadOnlyError;
      this.patch = throwReadOnlyError;
      this.sync = throwReadOnlyError;
      this._isReadOnly = true;
    }
  }, {
    key: "isReadOnly",
    get: function get() {
      return this._isReadOnly;
    }
  }, {
    key: "makeCommit",
    value: function () {
      var _makeCommit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(signer, newContent, newMetadata) {
        var _header$controllers;
        var header, patch, commit;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              header = headerFromMetadata(newMetadata, false);
              if (newContent == null) {
                newContent = this.content;
              }
              if (!(header.controllers && ((_header$controllers = header.controllers) === null || _header$controllers === void 0 ? void 0 : _header$controllers.length) !== 1)) {
                _context3.next = 4;
                break;
              }
              throw new Error('Exactly one controller must be specified');
            case 4:
              patch = jsonpatch.compare(this.content, newContent);
              commit = {
                header: header,
                data: patch,
                prev: this.tip,
                id: this.state.log[0].cid
              };
              return _context3.abrupt("return", _signDagJWS(signer, commit));
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function makeCommit(_x7, _x8, _x9) {
        return _makeCommit.apply(this, arguments);
      }
      return makeCommit;
    }()
  }], [{
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(ceramic, content, metadata) {
        var opts,
          signer,
          commit,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              opts = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_OPTS), opts);
              if (!(metadata !== null && metadata !== void 0 && metadata.deterministic) && opts.syncTimeoutSeconds == undefined) {
                opts.syncTimeoutSeconds = 0;
              }
              signer = opts.asDID ? {
                did: opts.asDID
              } : ceramic;
              _context4.next = 6;
              return TileDocument_1.makeGenesis(signer, content, metadata);
            case 6:
              commit = _context4.sent;
              return _context4.abrupt("return", ceramic.createStreamFromGenesis(TileDocument_1.STREAM_TYPE_ID, commit, opts));
            case 8:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function create(_x10, _x11, _x12) {
        return _create.apply(this, arguments);
      }
      return create;
    }()
  }, {
    key: "createFromGenesis",
    value: function () {
      var _createFromGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(ceramic, genesisCommit) {
        var _genesisCommit$header;
        var opts,
          commit,
          _args5 = arguments;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              opts = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_OPTS), opts);
              if ((_genesisCommit$header = genesisCommit.header) !== null && _genesisCommit$header !== void 0 && _genesisCommit$header.unique && opts.syncTimeoutSeconds == undefined) {
                opts.syncTimeoutSeconds = 0;
              }
              if (!genesisCommit.data) {
                _context5.next = 9;
                break;
              }
              _context5.next = 6;
              return _signDagJWS(ceramic, genesisCommit);
            case 6:
              _context5.t0 = _context5.sent;
              _context5.next = 10;
              break;
            case 9:
              _context5.t0 = genesisCommit;
            case 10:
              commit = _context5.t0;
              return _context5.abrupt("return", ceramic.createStreamFromGenesis(TileDocument_1.STREAM_TYPE_ID, commit, opts));
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      function createFromGenesis(_x13, _x14) {
        return _createFromGenesis.apply(this, arguments);
      }
      return createFromGenesis;
    }()
  }, {
    key: "deterministic",
    value: function () {
      var _deterministic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(ceramic, metadata) {
        var opts,
          commit,
          _args6 = arguments;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              opts = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_CREATE_OPTS), opts);
              metadata = _objectSpread(_objectSpread({}, metadata), {}, {
                deterministic: true
              });
              if (!(metadata.family == null && metadata.tags == null)) {
                _context6.next = 5;
                break;
              }
              throw new Error('Family and/or tags are required when creating a deterministic tile document');
            case 5:
              _context6.next = 7;
              return TileDocument_1.makeGenesis(ceramic, null, metadata);
            case 7:
              commit = _context6.sent;
              return _context6.abrupt("return", ceramic.createStreamFromGenesis(TileDocument_1.STREAM_TYPE_ID, commit, opts));
            case 9:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }));
      function deterministic(_x15, _x16) {
        return _deterministic.apply(this, arguments);
      }
      return deterministic;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(ceramic, streamId) {
        var opts,
          streamRef,
          _args7 = arguments;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              opts = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
              opts = _objectSpread(_objectSpread({}, DEFAULT_LOAD_OPTS), opts);
              streamRef = StreamRef.from(streamId);
              if (!(streamRef.type != TileDocument_1.STREAM_TYPE_ID)) {
                _context7.next = 5;
                break;
              }
              throw new Error("StreamID ".concat(streamRef.toString(), " does not refer to a '").concat(TileDocument_1.STREAM_TYPE_NAME, "' stream, but to a ").concat(streamRef.typeName));
            case 5:
              return _context7.abrupt("return", ceramic.loadStream(streamRef, opts));
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }));
      function load(_x17, _x18) {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "makeGenesis",
    value: function () {
      var _makeGenesis = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(signer, content, metadata) {
        var _metadata$controllers, _metadata;
        var header, result, commit;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!metadata) {
                metadata = {};
              }
              if (!(!metadata.controllers || metadata.controllers.length === 0)) {
                _context8.next = 9;
                break;
              }
              if (!signer.did) {
                _context8.next = 8;
                break;
              }
              _context8.next = 5;
              return _ensureAuthenticated(signer);
            case 5:
              metadata.controllers = [signer.did.hasParent ? signer.did.parent : signer.did.id];
              _context8.next = 9;
              break;
            case 8:
              throw new Error('No controllers specified');
            case 9:
              if (!(((_metadata$controllers = metadata.controllers) === null || _metadata$controllers === void 0 ? void 0 : _metadata$controllers.length) !== 1)) {
                _context8.next = 11;
                break;
              }
              throw new Error('Exactly one controller must be specified');
            case 11:
              header = headerFromMetadata(metadata, true);
              if (!((_metadata = metadata) !== null && _metadata !== void 0 && _metadata.deterministic && content)) {
                _context8.next = 14;
                break;
              }
              throw new Error('Initial content must be null when creating a deterministic Tile document');
            case 14:
              if (!(content == null)) {
                _context8.next = 18;
                break;
              }
              result = {
                header: header
              };
              dagCbor.encode(result);
              return _context8.abrupt("return", result);
            case 18:
              commit = {
                data: content,
                header: header
              };
              return _context8.abrupt("return", _signDagJWS(signer, commit));
            case 20:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }));
      function makeGenesis(_x19, _x20, _x21) {
        return _makeGenesis.apply(this, arguments);
      }
      return makeGenesis;
    }()
  }]);
  return TileDocument;
}(Stream);
TileDocument.STREAM_TYPE_NAME = 'tile';
TileDocument.STREAM_TYPE_ID = 0;
TileDocument = TileDocument_1 = __decorate([StreamStatic()], TileDocument);
export { TileDocument };